module.exports = __webpack_public_path__ + "static/media/equador.f4e871be.jpg";